import React, { useState, useEffect } from "react";
import {
  collection,
  getCountFromServer,
  getDocs,
  query,
  where,
  setDoc,
  doc,
} from "firebase/firestore";
import { db } from "../utils/firebase";
import { useParams } from "react-router-dom";

const VotingUI = ({ proposal, voter }) => {
  const [voteCount, setVoteCount] = useState(1);
  const [votesFor, setVotesFor] = useState(0);
  const [votesAgainst, setVotesAgainst] = useState(0);
  const [voted, setVoted] = useState(false);
  const [isVotingOver, setIsVotingOver] = useState(false);
  const { id, community } = useParams();
  const userID = localStorage.getItem("id");

  useEffect(() => {
    async function getVotes() {
      const colRef = collection(db, "Proposals", id, "Votes");
      const voteCount = (await getCountFromServer(colRef)).data().count || 1;

      setVoteCount(voteCount);

      const votesForQuery = query(
        collection(db, "Proposals", id, "Votes"),
        where("for", "==", true)
      );
      const votesForDocs = await getDocs(votesForQuery);
      setVotesFor(votesForDocs.size);

      const votesAgainstQuery = query(
        collection(db, "Proposals", id, "Votes"),
        where("for", "==", false)
      );
      const votesAgainstDocs = await getDocs(votesAgainstQuery);
      setVotesAgainst(votesAgainstDocs.size);

      const voteDocs = await getDocs(colRef);
      const found = voteDocs.docs.find((element) => element.id == userID);
      if (found) {
        setVoted(true);
      }
    }
    getVotes();

    async function isVotingOver() {
      if (proposal && proposal.endDate) {
        const v = new Date() - proposal.endDate.toDate();
        console.log(v);

        if (v > 0) {
          setIsVotingOver(true);
        }
      }
    }

    isVotingOver();
  }, [proposal]);

  const handleVoteFor = () => {
    setDoc(doc(db, "Proposals", id, "Votes", userID), {
      for: true,
      firstName: voter.name.given_name,
      dateCreated: new Date(),
      community: voter.community,
    });
    setVotesFor(votesFor + 1);
    setVoteCount(voteCount + 1);
    setVoted(true);
  };

  const handleVoteAgainst = () => {
    setDoc(doc(db, "Proposals", id, "Votes", userID), {
      for: false,
      firstName: voter.name.given_name,
      dateCreated: new Date(),
      community: voter.community,
    });
    setVotesAgainst(votesAgainst + 1);
    setVoteCount(voteCount + 1);
    setVoted(true);
  };

  return (
    <div>
      {isVotingOver ? (
        <div className="alert alert-dark text-center" role="alert">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-check-circle-fill"
            viewBox="0 0 16 16"
          >
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
          </svg>
          &nbsp;
          <span style={{ fontSize: 16 }}>Voting is over</span>
        </div>
      ) : (
        <>
          <h3 className="mb-4">Vote Here</h3>
          {voter.userTypeNumber > 1 ? (
            <>
              {voter.communitySlug == community && voter.userTypeNumber > 1 ? (
                <div style={{ marginBottom: 12 }}>
                  {voted ? (
                    <div className="alert alert-dark text-center" role="alert">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      &nbsp;
                      <span style={{ fontSize: 16 }}>
                        You have already voted
                      </span>
                    </div>
                  ) : (
                    <>
                      <button
                        className="btn btn-pills btn-success text-white  m-1"
                        type="button"
                        onClick={handleVoteFor}
                        disabled={voted}
                      >
                        Vote For
                      </button>
                      <button
                        className="btn btn-pills btn-danger text-white  m-1"
                        type="button"
                        onClick={handleVoteAgainst}
                        disabled={voted}
                      >
                        Vote Against
                      </button>
                    </>
                  )}
                </div>
              ) : (
                <div style={{ marginBottom: 12 }}>
                  <button
                    className="btn btn-pills btn-success text-white  m-1"
                    type="button"
                    onClick={handleVoteFor}
                    disabled={true}
                  >
                    Vote For
                  </button>
                  <button
                    className="btn btn-pills btn-danger text-white  m-1"
                    type="button"
                    onClick={handleVoteAgainst}
                    disabled={true}
                  >
                    Vote Against
                  </button>
                </div>
              )}
              <p>
                Total Votes:{" "}
                {voteCount == 1 && votesFor == 0 && votesAgainst == 0
                  ? 0
                  : voteCount}
              </p>
              <div
                className="progress-stacked"
                style={{
                  // margin: -10,
                  height: 24,
                }}
              >
                <div
                  className="progress"
                  role="progressbar"
                  aria-label="Segment one"
                  aria-valuenow={(votesFor / voteCount) * 100}
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{
                    width: (votesFor / voteCount) * 150 + "%",
                    height: 24,
                  }}
                >
                  <div className="progress-bar bg-success px-2 text-center">
                    {/* For ({(votesFor / voteCount).toFixed(2) * 100 + "%"}) */}
                  </div>
                </div>
                <div
                  className="progress"
                  role="progressbar"
                  aria-label="Segment two"
                  aria-valuenow={(votesAgainst / voteCount) * 100}
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{
                    width: (votesAgainst / voteCount) * 150 + "%",
                    height: 24,
                  }}
                >
                  <div className="progress-bar bg-danger px-2 text-center">
                    {/* Against ({(votesAgainst / voteCount).toFixed(2) * 100 + "%"}) */}
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  For (
                  {votesFor && voteCount
                    ? (votesFor / voteCount).toFixed(2) * 100 + "%"
                    : "0%"}
                  )
                </div>
                <div>
                  Against (
                  {votesAgainst && voteCount
                    ? (votesAgainst / voteCount).toFixed(2) * 100 + "%"
                    : "0%"}
                  )
                </div>
              </div>
            </>
          ) : (
            <>
              <p
                style={{
                  margin: "10px auto 0",
                  display: "flex",
                  justifyContent: "center",
                  color: "#f2a445",
                }}
              >
                Only Verified Members Can Vote
              </p>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default VotingUI;
